/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Portability_LabelInputs */

const es_privacy_policy_rights_portability_label = /** @type {(inputs: Privacy_Policy_Rights_Portability_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portabilidad`)
};

const en_privacy_policy_rights_portability_label = /** @type {(inputs: Privacy_Policy_Rights_Portability_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portability`)
};

/**
* | output |
* | --- |
* | "Portability" |
*
* @param {Privacy_Policy_Rights_Portability_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_portability_label = /** @type {((inputs?: Privacy_Policy_Rights_Portability_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Portability_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_portability_label(inputs)
	return en_privacy_policy_rights_portability_label(inputs)
});
export { privacy_policy_rights_portability_label as "privacy_policy.rights.portability_label" }